import React from 'react';
import FontAwesomeIcon from '../../Icon';
import moment from 'moment';
import { useSelector } from 'react-redux';
import InboxEmpty from '../InboxEmpty/InboxEmpty';
import './inbox-messages-list.scss';

const InboxMessagesList = ({ inboxList, onSelectItem, selectedId, loader }) => {
  const user = useSelector((state: any) => state.auth?.user || {});

  return inboxList && inboxList.length > 0
    ? inboxList.map((item, i) => {
        return (
          <div
            className={
              item.referenceId === selectedId
                ? 'inbox-thread-row selected'
                : 'inbox-thread-row'
            }
            key={i}
            onClick={() => onSelectItem(item)}
          >
            <div className="thread-icon">
              <FontAwesomeIcon
                glyph={item.referenceType === 'Ticket' ? 'wrench' : 'building'}
                weight="light"
                size="custom"
              />
            </div>
            <div className="thread-info">
              <div className="timestamp">
                {item.receivedOn &&
                  moment(item.receivedOn).format('MM/DD/YYYY')}
              </div>
              {item.sentBy !== user.id && item.isRead === false && (
                <div className="unread-dot" />
              )}
              <div className="property-name">{item.propertyName}</div>
              <div className="suite-name">{item.suiteName}</div>
              {item.referenceType === 'Ticket' && (
                <div className="description">{item.description} </div>
              )}
            </div>
          </div>
        );
      })
    : !loader && <InboxEmpty message={'Your inbox is empty.'} />;
};

export default InboxMessagesList;
